import { CLOSE_ALERT, CREATE_ALERT } from "./types"
import { v4 as uuid } from 'uuid'


/**
 * 
 * @param {Object} payload 
 * @property {boolean} payload.permanent whether the notification can be closed
 * @property {string} payload.variant NOTIFICATION_INFO | NOTIFICATION_WARNING | NOTIFICATION_ERROR | NOTIFICATION_SUCCESS
 * @property {node} payload.component component that should be displayed in the alert
 */
export const createAlert = payload => {
  if (payload && !payload.id) {
    payload.id = uuid()
  }
  return dispatch => dispatch({
    type: CREATE_ALERT,
    payload
  })
}

/**
 * 
 * @param {object} payload 
 * @property {int?} payload.id the id of the alert to close. the last alert will be removed if id is not given
 */
export const closeAlert = payload => {
  return dispatch => dispatch({
    type: CLOSE_ALERT,
    payload
  })
}